import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../../components/Hint/Hint';
import Switch from '../../components/Switch/Switch';
import TagInput from '../../components/TagInput/TagInput';
import InputBox from '../../components/InputBox/InputBox';
import SingleSelect from '../../components/SingleSelect/SingleSelect';
import { useMenu } from '../../contexts/MenuContext';
import withForm from '../../layouts/withForm';
import Languages from "./Languages";
import DebugLogs from "./DebugLogs";
import "./SecurityCloudflareTurnstile.scss";
const SecurityCloudflareTurnstile = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

    const isEnabled = (value) => {
        return value === "1" || value === true || value === 1;
    };

    return (
        <>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Site Key", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Add Cloudflare Site Key", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.cloudflare_turnstile.site_key"
                                        placeholder=""
                                        value={settingData?.security?.cloudflare_turnstile?.site_key}
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Secret key", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Add Cloudflare Secret Key", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.cloudflare_turnstile.secret_key"
                                        placeholder=""
                                        value={settingData?.security?.cloudflare_turnstile?.secret_key}
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-input border-top border-bottom mb-lg">
                <div className="title-group py-3">
                    <h5 className="pl-heading-1 fw-600 text-text">{__("General Settings:", "ultimate-security")}</h5>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Theme", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Theme", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            { label: 'Light', value: 'light' },
                                            { label: 'Dark', value: 'dark' },
                                            { label: 'Auto', value: 'auto' }
                                        ]}
                                        initialValue={settingData?.security?.cloudflare_turnstile?.theme || 'light'}
                                        name="security.cloudflare_turnstile.theme"
                                        selected={settingData?.security?.cloudflare_turnstile?.theme}
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Language", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Language", "ultimate-security")}/>                                    
                                    <SingleSelect
                                    options={Languages}
                                    initialValue={settingData?.security?.cloudflare_turnstile?.language || 'auto'}
                                    name="security.cloudflare_turnstile.language"
                                    handleChange={handleChange}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable Submit Button", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Disable submit button", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px'}}>
                                    <p className="pl-body text-text">{__("When enabled, the user will not be able to click submit until the Turnstile challenge is completed.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.disable_submit_button"
                                    checked={settingData?.security?.cloudflare_turnstile?.disable_submit_button} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-input border-top border-bottom mb-lg">
                <div className="title-group py-3">
                    <h5 className="pl-heading-1 fw-600 text-text">{__("Advanced Settings:", "ultimate-security")}</h5>
                    <p className="pl-body text-text">{__("These settings are for more advanced customisation. If you are not sure about these, they do not need to be changed.", "ultimate-security")}</p>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Widget Size", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose idget Size", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            { label: 'Normal (300px)', value: 'normal' },
                                            { label: 'Flexible (100%)', value: 'flexible' },
                                            { label: 'Compact (150px)', value: 'compact' }
                                        ]}
                                        initialValue={settingData?.security?.cloudflare_turnstile?.widget_size || 'normal'}
                                        name="security.cloudflare_turnstile.widget_size"
                                        handleChange={handleChange}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Appearance Mode", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose idget Size", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            { label: 'Always', value: 'always' },
                                            { label: 'Interaction Only', value: 'interaction-only' },
                                        ]}
                                        initialValue={settingData?.security?.cloudflare_turnstile?.appearance_mode || 'always'}
                                        name="security.cloudflare_turnstile.appearance_mode"
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Defer Scripts", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable differ scripts", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("When enabled, the javascript files loaded by the plugin will be deferred. You can disable this if it causes any issues with your other optimisations.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.defer_scripts"
                                    checked={settingData?.security?.cloudflare_turnstile?.defer_scripts} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Custom Error Message", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Add Cloudflare Site Key", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="custom_error_message"
                                        value={settingData?.security?.cloudflare_turnstile?.custom_error_message}
                                        placeholder="Please verify that you are human."
                                        handleChange={handleChange}
                                    />
                                </div>  
                                <div className="col-auto" style={{marginTop:"10px"}}>
                                    <div className="title-group" style={{marginLeft: '30px'}}>
                                        <p className="pl-body text-text">{__("When enabled, the javascript files loaded by the plugin will be deferred. You can disable this if it causes any issues with your other optimisations.", "ultimate-security")}</p>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Extra Failure Message", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Extra Failur Message", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.extra_failure_message"
                                    checked={settingData?.security?.cloudflare_turnstile?.extra_failure_message} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* After the extra_failure_message switch */}
            {isEnabled(settingData?.security?.cloudflare_turnstile?.extra_failure_message) && (
            <div className="setting-unit mb-lg">
                <div className="row">
                <div className="col-lg-5">
                    <div className="title-group">
                    <h5 className="pl-heading-1 fw-600 text-text">
                        {__("Failure Message Content", "ultimate-security")}
                    </h5>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="row justify-content-between">
                    <div className="col-lg-10">
                        <div className="title-group d-flex align-items-center">
                        <Hint position="top" content={__("This message will appear if the challenge fails", "ultimate-security")}/>
                        <InputBox
                            name="security.cloudflare_turnstile.failure_message"
                            placeholder="Failed to verify you are human. Please contact us if you are having issues."
                            value={settingData?.security?.cloudflare_turnstile?.failure_message}
                            handleChange={handleChange}
                        />
                        </div>
                        <div className="col-auto" style={{marginTop:"10px"}}>
                        <div className="title-group" style={{marginLeft: '30px'}}>
                            <p className="pl-body text-text">
                            {__("This will show a message below the Turnstile widget if they receive the 'Failure!' response. Useful to give instructions in the very rare case a valid user is being flagged as spam.", "ultimate-security")}
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            )}
            
            <div className="setting-input border-top border-bottom mb-lg">
                <div className="title-group py-3">
                    <h5 className="pl-heading-1 fw-600 text-text">{__("Whitelist Settings", "ultimate-security")}</h5>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Logged In Users", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Logged In Users", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("When enabled, logged in users will not see the Turnstile challenge.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.logged_in_users"
                                    checked={settingData?.security?.cloudflare_turnstile?.logged_in_users} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("IP Adddresses", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Add Ip Adresses", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.cloudflare_turnstile.ip_addresses' 
                                        type='Ip Adresses' 
                                        initialTags={Array.isArray(settingData?.security?.cloudflare_turnstile?.ip_addresses) ? 
                                            settingData?.security?.cloudflare_turnstile?.ip_addresses : []} 
                                        handleChange={handleChange} 
                                    />
                                </div>  
                                <div className="col-auto" style={{marginTop:"10px",marginLeft: '30px'}}>
                                    <div className="title-group">
                                        <p className="pl-body text-text">{__("One per line. Wildcards are not supported. All visitors with listed IP addresses will not see the Turnstile challenge. Warning: If an attacker knows one of the whitelisted IP addresses, they might be able to spoof that address to bypass Turnstile.", "ultimate-security")}</p>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("User Agents", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Add User Agents", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.cloudflare_turnstile.user_agents' 
                                        type='User Agents' 
                                        initialTags={Array.isArray(settingData?.security?.cloudflare_turnstile?.user_agents) ? 
                                                    settingData?.security?.cloudflare_turnstile?.user_agents : []} 
                                        handleChange={handleChange} 
                                    />
                                </div>  
                                <div className="col-auto" style={{marginTop:"10px",marginLeft: '30px'}}>
                                    <div className="title-group">
                                        <p className="pl-body text-text">{__("One per line. All visitors with listed User Agents will not see the Turnstile challenge. Warning: If an attacker knows one of the whitelisted User Agents, they might be able to spoof that User Agent to bypass Turnstile.", "ultimate-security")}</p>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-input border-top border-bottom mb-lg">
                <div className="title-group py-3">
                    <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Turnstile on your forms:", "ultimate-security")}</h5>
                    <p className="pl-body text-text">{__("Select the dropdown for each integration, and choose when specific forms you want to enable Turnstile on.", "ultimate-security")}</p>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Default WordPress Forms", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable on Wordpress login form", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("WordPress Login", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.wordpress_login"
                                    checked={settingData?.security?.cloudflare_turnstile?.wordpress_login} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable on Wordpress register form", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("WordPress Register", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.wordpress_register"
                                    checked={settingData?.security?.cloudflare_turnstile?.wordpress_register} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable on Wordpress reset password", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("WordPress Reset Password", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.wordpress_reset_password"
                                    checked={settingData?.security?.cloudflare_turnstile?.wordpress_reset_password} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable on WordPress Comment", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("WordPress Comment", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.cloudflare_turnstile.wordpress_comment"
                                    checked={settingData?.security?.cloudflare_turnstile?.wordpress_comment} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="other-integrations mb-lg">
                 <div className="title-group mb-4">
                    <h6>{__("Other Integrations","ultimate-security")}</h6>
                 </div>
                 <div className="other-links">
                    <h6>{__("You can also enable Turnstile on","ultimate-security")} <a href="https://woocommerce.com/" target="_blank">{__("WooCommerce", "ultimate-security")}</a>
                        <a href="https://easydigitaldownloads.com/" target="_blank">{__("Easy Digital Downloads", "ultimate-security")}</a>
                        <a href="https://www.paidmembershipspro.com/" target="_blank">{__("Paid Memberships PRO", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/contact-form-7/" target="_blank">{__("Contact Form 7", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/wpforms-lite/" target="_blank">{__("WPForms", "ultimate-security")}</a>
                        <a href="https://www.gravityforms.com/" target="_blank">{__("Gravity Forms", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/fluentform/" target="_blank">{__("Fluent Forms", "ultimate-security")}</a>
                        <a href="https://jetpack.com/features/forms/" target="_blank">{__("Jetpack Forms", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/formidable/" target="_blank">{__("Formidable", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/forminator/" target="_blank">{__("Forminator", "ultimate-security")}</a>
                        <a href="https://elementor.com/features/forms/" target="_blank">{__("Elementor Forms", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/mailchimp-for-wp/" target="_blank">{__("Mailchimp for WordPress", "ultimate-security")}</a>
                        <a href="https://www.mailpoet.com/" target="_blank">{__("MailPoet", "ultimate-security")}</a>
                        <a href="https://www.kadencewp.com/kadence-blocks/" target="_blank">{__("Kadence Forms", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/buddypress/" target="_blank">{__("BuddyPress", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/bbpress/" target="_blank">{__("bbPress", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/ultimate-member/" target="_blank">{__("Ultimate Member", "ultimate-security")}</a>
                        <a href="https://memberpress.com/" target="_blank">{__("MemberPress", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/wp-members/" target="_blank">{__("WP-Members", "ultimate-security")}</a>
                        <a href="https://wordpress.org/plugins/wp-user-frontend/" target="_blank">{__("WP User Frontend", "ultimate-security")}</a> {__("and", "ultimate-security")}
                        <a href="https://wordpress.org/plugins/wpdiscuz/" target="_blank">{__("wpDiscuz", "ultimate-security")}</a> {__(". Simply install the plugin and new settings will appear above.", "ultimate-security")}
                    </h6> 
                 </div>
            </div> */}
            {settingData?.more?.extra?.enable_turnstile_debugging === "1" && (
               <DebugLogs />
            )} 
        </>
    )
}
export default withForm(SecurityCloudflareTurnstile,'security.cloudflare_turnstile');